import { render, staticRenderFns } from "./ImportFromJiraDialog.vue?vue&type=template&id=2e004603"
import script from "./ImportFromJiraDialog.vue?vue&type=script&lang=js"
export * from "./ImportFromJiraDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportFromJiraDialog.vue?vue&type=style&index=0&id=2e004603&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports